/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound":"404 - Page Not Found",
  "ComingSoon":"Coming soon",
  "YesanPersonalFinance":"Yesan, Personal Finance",
  "Yesan":"Yesan",
  "PersonalFinance":"Personal Finance",
  "YesanDownload":"Yesan Download",
  "ThisWebsiteUsesCookies":"We use cookies to collect and analyse information on our site performance and usage, and to provide social media features. By continuing, you consent with our ",
  "IGotIt":"OK",

  "BecomeFinanciallyFree":"Become Financially Free",
  "inStepsAndActions":"in 8 steps and 3 actions.",
  "TrackPlanAnalyze":"Track. Plan. Analyze.",
  "FTrack":"1. Track",
  "FPlan":"2. Plan",
  "FAnalyze":"3. Analyze",

  "Features":"Features",
  "FeaturesSubHeading":"Pure beginner, already financially literate, this is the app you need to become financially free.",
  "ManageAccounts":"Manage Accounts",
  "CashLiquidFixedAssetsLiabilities":"Cash, Liquid, Fixed Assets & Liabilities.",
  "TrackTransactions":"Track Transactions",
  "IncomesExpensesTransferInvestments":"Incomes, Expenses, Transfer, Investments.",
  "ImportExport":"Import / Export",
  "YourDataAlwaysAccessible":"Your data always accessible.",
  "PlanYourFreedom":"Plan your freedom",
  "StepsAwayFromFI":"8 steps away from Financial Independence.",
  "BudgetsAndGoals":"Budgets & Goals",
  "CheckYourProgressAndAchieve":"Check your progress and achieve your financial goals.",
  "DashboardAndAnalytics":"Dashboard & Analytics",
  "ReviewLearnOptimizeWith":"Review, Learn, Optimize with Charts, Insights, Tools.",
  "Security":"Security",
  "MilitaryGradeEncryption":"Military grade Encryption, Biometry support, data stored on your devices.",
  "OfflineMode":"Offline mode",
  "YourDataAlwaysAccessibleAndModif":"Your data always accesible and modifiable.",

  "Track":"Track",
  "Income":"Income",
  "Expense":"Expense",
  "Transfer":"Transfer",
  "transactionsAndManageAccounts":"transactions & manage variety of Accounts:",

  "checkings":"Checking",
  "savings":"Savings",
  "realEstate":"Real Estate",
  "stocks":"Stock markets",
  "bonds":"Bonds",
  "crypto":"Crypto",
  "notes":"Notes, Cash Wallet",
  "envelopes":"Envelopes",
  "privateEquity":"Private Equity",
  "metal":"Metal",
  "retirement":"Retirement",
  "lifeInsurance":"Life Insurance",
  "intellectualProperty":"Intellectual Property",
  "otherLiquidAsset":"Other Liquid Asset",
  "otherFixedAsset":"Other Fixed Asset",
  "mortgage":"Mortgage",
  "loan":"Consumer Loan",
  "creditCard":"Credit card",
  "otherLiability":"Other Liability",

  "AccountsManagement":"Accounts management",
  "MultipleAccountsTypesAndGrouping":"Multiple accounts types and grouping",
  "LinkAccounts":"Link Accounts from your institutions (available only in certain countries)",
  "SmartAccounts":"Smart accounts",
  "AddEditDeleteTransactions":"Add / Edit / Delete transactions",
  "TickVerifiedTransactions":"Tick verified transactions",
  "CategorizeTransactions":"Categorize transactions",
  "TagTransactions":"Tag transactions",
  "TrackKakeiboType":"Track Kakeibo type",
  "TrackInvestments":"Track Investments (available only in certain countries)",
  "ImportFromCSVFile":"Import in full or incrementally transactions from CSV file",
  "ExportToCSVFile":"Export transations to CSV file",

  "stepsTowardsFIPlanBudgetingReachGoals":"8 steps towards Financial Independence plan, detailed budgeting, reach your financial goals faster.",
  "levelsTowardsFI":"8 levels towards Financial Independence",
  "EstablishBudgetsPer":"Establish Budgets per",
  "account":"account",
  "accountType":"account type",
  "KakeiboType":"Kakeibo type",
  "category":"category",
  "tag":"tag",
  "label":"label",
  "TrackBudgetsPerFrequency":"Track budgets per frequency",
  "CreateGoalsOnSpendingBalanceCashFlowActions":"Create Goals on spending, balance, cashflow, actions",
  "TrackGoalsProgress":"Track Goals progress",

  "ReviewLearnOptimizeWithReportsCharts":"Review, Learn, Optimize with Reports, Charts, Trends, Insights, Tools.",
  "Dashboard":"Dashboard",
  "FSNetWorth":"Financial Statements: Net Worth",
  "FSPnL":"Financial Statements: Income Statement / Profit & Loss",
  "FSBalanceSheetAssetsLiabilities":"Financial Statements: Balance Sheet, Assets, Liabilities",
  "FSCashFlow":"Financial Statements: Cash Flow Statement, Debit Credit, Flows",
  "FSFlows":"Financial Statements: Flows",
  "FSRatios":"Financial Statements: Ratios",
  "TrendsMonthEnd":"Month End trends: Incomes & Expenses, Cash Flow",
  "TrendsPerformance":"Performance trends: YoY, MoM, WoW",
  "IncomeTrendsPer":"Income trends per",
  "SpendingTrendsPer":"Spending trends per",
  "RecurringItemsIE":"Recurring items: Incomes & Expenses",
  "DebtProgressTrends":"Debt Progress trends",
  "KakeiboMTDReviewTrends":"Kakeibo: MTD review, last month, trends",
  "FIWCLE":"Financial Independence: Wall Chart, Expenses by Life Energy",
  "DebtPaydownSnowballAvalanche":"Debt Paydown: Snowball, Avalanche",
  "FullyCustomizableAnalyticsRange":"Fully customizable analytics time range",

  "ContactUs":"Contact us",
  "Privacy":"Privacy",
  "Terms":"Terms",
  "About":"About",
  "IAgreeToThe":"I agree to the",
  "AndThe":"and the",
  "PrivacyPolicy":"Privacy Policy",
  "TermsOfUse":"Terms of Use",

  "DigitalSoftwareExperienceTagline":"Digital software experience\n for the modern world",
  "DigitalExperience":"Digital Experience",
  "SoftwareForTheModernWorld":"Software for the modern world",
  "MobileApplications":"Mobile Applications",
  "forConnectedAndOfflineHumans":"for connected and offline humans",
  "CloudSaaS":"Cloud SaaS",
  "ResponsiveAndWebServices":"Responsive and Web services",
  "PersonalFinanceServices":"Personal Finance Services",
  "YS_p1":"Yesan is a dynamic software company specializing in the development of cutting-edge mobile applications tailored for consumers. With a keen understanding of the evolving needs and preferences of today's tech-savvy users, Yesan is dedicated to crafting intuitive, engaging, and feature-rich mobile experiences that enrich the lives of its users.",
  "YS_p2":"At the core of Yesan's mission is a relentless commitment to innovation and creativity, each product is meticulously crafted to deliver seamless functionality and an exceptional user experience.",
  "PersonalFinanceApplication":"Personal Finance Application",
  "YPF_p1":"Yesan, Personal Finance is a cutting-edge personal finance mobile application designed to empower users with comprehensive financial management tools conveniently accessible at their fingertips. With a sleek and intuitive interface, Yesan, Personal Finance offers a holistic approach to managing finances, catering to users of all levels of financial literacy.",
  "YPF_p2":"Key features include budget tracking, expense categorization, and real-time transaction monitoring, allowing users to gain insights into their spending habits effortlessly. The app also offers customizable budgeting options, enabling users to set financial goals and track their progress over time.",
  "YPF_p3":"Moreover, Yesan, Personal Finance prioritizes security, employing state-of-the-art encryption protocols to safeguard users' sensitive financial information. With bank-level security measures, users can confidently link their accounts and synchronize transactions without compromising privacy.",
  "YPF_p4":"Yesan, Personal Finance goes beyond basic budgeting by offering insightful analytics and personalized recommendations to optimize financial decisions. Whether it's identifying potential saving opportunities, monitoring investment portfolios, or managing debt repayment strategies, the app provides tailored insights to help users achieve their financial objectives.",
  "Discover":"Discover",

  "Firstname":"Firstname",
  "Lastname":"Lastname",
  "Company":"Company",
  "Subject":"Subject",
  "Email":"Email",
  "Message":"Message",
  "ThankYouForContactingUs":"Thank you for contacting us",
  "ValidFirstnameRequired":"Valid firstname is required.",
  "ValidLastnameRequired":"Valid lastname is required.",
  "ValidEmailAddressRequired":"Please enter a valid email address.",
  "ValidSubjectRequired":"Please select a valid subject.",
  "ValidMessageRequired":"Please enter a valid message.",
  "UnableToSendTheFormPleaseRetryLater":"Unable to send the form please retry later.",
  "Information":"Information",
  "Sales":"Sales",
  "Support":"Support",
  "Press":"Press",
  "Partnership":"Partnership",
  "Other":"Other",
  "Blog":"Blog",

  "Accept":"Accept",
  "Decline":"Decline",

  "WorklogCalendar":"Worklog Calendar for Jira",

  "DirectlyAccessibleInProjectApps":"Directly accessible in project apps",
  "VisualizeWhereYouSpentYourTime":"Visualize where you spent your time",
  "AllYourWorklogsInACalendar":"All your Jira worklogs in a calendar.",
  "MonthSummary":"Month summary",
  "CheckIfYouForgotToLogTime":"Check if you forgot to log time.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Directly access the issues and update time",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Click on the worklog item to directly access the issues and edit your tracked time",
  "AlsoAvailableInDarkMode":"Also available in dark mode",
  "DirectlyLogWorkOnTheCalendarVisually":"Directly log work on the calendar visually",
  "ClickOnTheCalendarToCreateNewWorklog":"Click on the calendar to create new worklog",

  "AppsForAtlassian":"Apps for Atlassian",
  "YCL_p1":"Visualize all your worklogs on a calendar with month, week, work week, day views.",
  "YCL_p2":"Log work directly from the calendar visually selecting the time slot.",
  "YCL_p3":"Identify if you forgot to track time for your timesheets.",
  "YCL_p4":"Available in your language: English (UK), English (US), Chinese (Simplified), Chinese (Traditional), Czech, Danish, Dutch, Estonian, Finnish, French, German, Hungarian, Icelandic, Italian, Japanese, Korean, Norwegian, Polish, Portuguese (Brazil), Portuguese (Portugal), Russian, Spanish, Swedish, Turkish.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Financial Portfolio for Jira",
  "BringRealFinancialPortfolio":"Bring real financial portfolio management to Jira. Track budgets, CapEx/OpEx, and project costs in one place.",
  "YFPAboutQ":"How much are our Jira projects really costing us?",
  "YFPAbout":"Financial Portfolio for Jira\nFinance leaders and PMOs struggle to answer a simple question:\nHow much are our Jira projects really costing us?\nJira tracks work.\nFinance tracks budgets.\nThis app finally connects the two.\n\nFinancial Portfolio turns Jira into a lightweight PPM + Financial planning platform — without needing expensive enterprise tools.",
  "YFPPorfolioQ":"Portfolio Budgets & Tracking",
  "YFPPorfolioP":"Create portfolios across multiple Jira projects and define: Budget amount, Currency, Date range, Included projects, teams. Track actual costs automatically as work happens in Jira.",
  "YFPPorfolioListQ":"Portfolios",
  "YFPPorfolioListP":"Create financial portfolios that combine multiple Jira projects and instantly see: Budget vs Actual cost, Real-time project burn rate, CapEx vs OpEx breakdown, Cost per issue and project, Exportable financial reports. All powered directly by Jira worklogs.",
  "CostQ":"Automatic Cost Calculation",
  "CostP":"Turn time tracking into real financial data. The app: Reads Jira worklogs, Applies hourly rates, Calculates real project costs daily. No spreadsheets. No manual work.",
  "RatesQ":"Rates",
  "RatesP":"Set hourly rate per project, team, globally",
  "ReportQ":"CSV Financial Reporting",
  "ReportP":"Export portfolio financial data in seconds. Perfect for: Finance teams, CFO reporting, Budget planning, Audit support",
  "SettingsQ":"CapEx vs OpEx Classification",
  "SettingsP":"Support accounting and audit requirements. Classify work into: Capitalizable development (CapEx), Operational work (OpEx). Generate exportable reports ready for finance teams."
};

export const documents = {
};
